export class BydCountry {
  byDCountries: Array<string>;
}
